import React from "react";
import { FormControl, FormLabel, FormHelperText, Box } from "@material-ui/core";
import { useField } from "formik";
import MyCheckbox from "./MyCheckbox";

const MyCheckboxGroup = ({
  label,
  options,
  optionalChildren,
  disabled,
  style,
  ...props
}) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : "";
  return (
    <FormControl style={style} error={!!errorText} disabled={disabled}>
      <FormLabel component="legend">{label}</FormLabel>
      <Box display="flex">
        {options.map(({ label, value }, index) => (
          <MyCheckbox
            key={index}
            {...field}
            type="checkbox"
            value={value}
            label={label}
            disabled={disabled}
          />
        ))}
      </Box>
      <Box ml={4} mt={1}>
        {optionalChildren}
      </Box>
      <FormHelperText>{errorText}</FormHelperText>
    </FormControl>
  );
};

export default MyCheckboxGroup;
